import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAuthState } from "../../../../helper/Context/context";


export const AdminSidebar = (props) => {

    const { isopen, active, subMenu, setIsOpen } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, UserFullName, RoleID } = userDetails

    // const [toggleactive, settoggleactive] = useState("dashboard")
    const [ReportOpen, setReportOpen] = useState(false)
    const [Open, setOpen] = useState(false)


    const [AdminReportOpen, setAdminReportOpen] = useState(false)

    const [Expand, setExpand] = useState(false)

    const ExpandSidebar = (value) => {
        if (value == 'Enter') {
            setIsOpen(true)
            // console.log('Enter')
        } else {
            setIsOpen(false)
            // console.log('Leave')
        }
    }
    return (
        <div
         
            className="left-slidebar"
            style={(isopen || Expand)?{ width:"200px" }:{display:'none'}}
            
        >
            <div className="navbar-brand-wrapper d-flex align-items-center justify-content-center ">
                <span className="navbar-brand brand-logo bg-white rounded p-1">
                    <img
                        style={{ width: (isopen || Expand) ? "100%" : "100%" }}
                        src="static/assets/img/nav/logo.png"
                        className="logo"
                        alt="logo"
                    />
                </span>

            </div>

            <nav
                className="sidebar  sidebar-offcanvas" id="sidebar"
                style={{ maxHeight: (isopen || Expand) ? "" : " calc(100vh - 150px)" }}
            >
                <ul className="nav d-block">

                     <li
                                className={Open || active === "dashboard" ? " nav-item active" : "nav-item sidebar_item"}>
                                <Link to='/MainDashboard' className="nav-link ">
                                    <img src="static/assets/img/nav/dashboard.png" className="menu-icon" />
                                    <span
                                        className="menu-title"
                                        style={{ display: (isopen || Expand) ? "" : "none" }}
                                    >
                                    Dashboard
                                    </span>
                                </Link>
                            </li>
                     
                


                </ul>
            </nav>
        </div>
    );
}
